import React from "react";
import { Button, Modal, ModalFooter } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
/**
 * Classic info dialog shown when the user tries to save a product whose primary
 * content type differs from the type already established by the title's other
 * products. Displays the fixed, verbatim message from the issue and a single
 * close button; it does not offer a way to bypass the rule (the user must create
 * another Title, and the backend guard is the non-bypassable backstop).
 */
export var ProductPrimaryContentTypeMismatchModal = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(Modal, { open: open, onClose: onClose, label: formatMessage({
            id: "ui-br-agency.product.primaryContentType.mismatch.heading",
        }), size: "small", dismissible: true, footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: onClose },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.close" }))) },
        React.createElement(FormattedMessage, { id: "ui-br-agency.product.validation.primaryContentType.titleMismatch" })));
};
